import createIndexedDBStorage from "redux-persist-indexeddb-storage";

export const persistStorage = createIndexedDBStorage({
  name: "myApp",
  storeName: "persistStore",
});
